import React from 'react';
import cn from 'classnames';

import {IMobileAppProps} from './IMobileApp';
import {AppleStore, AppleStoreQR} from './Subcomponents';

import styles from './MobileApp.module.scss';

const storesMap = {
	apple: {
		badge: <AppleStore />,
		qr: <AppleStoreQR />,
	},
};

const MobileApp = ({classNames, store}: IMobileAppProps) => {
	return (
		<div className={cn(styles['mobile-app'], classNames)}>
			<button type="button" className={styles['mobile-app__trigger']}>
				{storesMap[store].badge}
			</button>
			<div className={styles['mobile-app__qr']}>{storesMap[store].qr}</div>
		</div>
	);
};

export default MobileApp;
